import {
  FETCH_SUPERSET_TOKEN_REQUEST,
  FETCH_SUPERSET_TOKEN_SUCCESS,
  FETCH_SUPERSET_TOKEN_FAILURE,
  SET_MONITOR_QUERY_DATA
} from '../actions/monitorActions';
import moment from 'moment';
import { TIMEZONE } from '../utils/constants';

interface MonitorState {
  token: string | null;
  loading: boolean;
  error: string | null;
  monitorQueryData: {
    startTime: string;
    endTime: string;
    timeZone: string;
    providerName: string[] | null;
    partnerName: string[] | null;
    marketName: string[] | null;
  };
}

const initialState: MonitorState = {
  token: null,
  loading: false,
  error: null,
  monitorQueryData: {
    startTime: moment().clone().startOf("day").format("YYYY-MM-DDTHH:mm:ss"),
    endTime: moment().format("YYYY-MM-DDTHH:mm:ss"),
    timeZone: TIMEZONE,
    providerName: null,
    partnerName: null,
    marketName: null
  }
};

const monitorReducer = (state = initialState, action: any): MonitorState => {
  switch (action.type) {
    case FETCH_SUPERSET_TOKEN_REQUEST:
      return {
        ...state,
        loading: true,
        error: null
      };
    case FETCH_SUPERSET_TOKEN_SUCCESS:
      return {
        ...state,
        token: action.payload.token,
        loading: false,
        error: null
      };
    case FETCH_SUPERSET_TOKEN_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload
      };
    case SET_MONITOR_QUERY_DATA:
      return {
        ...state,
        monitorQueryData: action.payload
      };
    default:
      return state;
  }
};

export default monitorReducer; 